import carolineImg from '@/assets/caroline.png';
import janeImg from '@/assets/jane.png';
import lisaImg from '@/assets/lisa.png';
import monicaImg from '@/assets/monica-1.png';
import valentinaImg from '@/assets/valentina.png';
import zoeImg from '@/assets/zoe.png';
import TestimonialsSection from '@/components/TestimonialsSection';
import useFunnelNavigation from '@/hooks/useFunnelNavigation';
import { getBrand } from '@/utils/getBrand';

export const TestimonialsLanding = () => {
  const { navigateToQuiz, navigateToCheckout } = useFunnelNavigation();
  const { brandName } = getBrand();

  const testimonials = [
    {
      name: 'Valentina T., 36',
      role: 'Purchasing specialist',
      text: '“It’s like having a personal recruiter for a busy mom. I went from silence to multiple interviews in a few weeks—while keeping our family routine. I ended up with several great choices. Wish I’d found it earlier!”',
      verified: true,
      image: valentinaImg,
    },
    {
      name: 'Jane A., 31',
      role: 'Digital marketing manager',
      text: '“The offer I got checked every box—flex schedule, remote, wellness days, and a clear ‘no meetings after 4’ policy. The benefits also include paid parental leave and a childcare allowance:)”',
      verified: true,
      image: janeImg,
    },
    {
      name: 'Zoe J., 28',
      role: 'Software engineer',
      text: '“This is crazy. I went from five applications during my kid’s nap to hundreds auto-sent while I’m cooking or playing with my little one. What??”',
      verified: true,
      image: zoeImg,
    },
    {
      name: 'Caroline S., 43',
      role: 'PR Specialist',
      text: `“${brandName} showed me openings I never would’ve found in the little free time I had. One turned out to be a perfect fit—flexible hours, family benefits, and real growth. I’m thrilled with my new job!”`,
      verified: true,
      image: carolineImg,
    },
    {
      name: 'Lisa K., 24',
      role: 'Data analyst',
      text: '“I asked for a four-day workweek with no surprise overtime—and that’s exactly what I landed. My schedule is predictable, there’s no after-hours Slack, and Fridays are fully for my family. It finally feels sustainable.”',
      verified: true,
      image: lisaImg,
    },
    {
      name: 'Monica H., 41',
      role: 'Product manager',
      text: '“The auto-apply and personalized resumes saved me so much time! I even landed a solid pay increase compared to my last job. Couldn’t ask for more!!”',
      verified: true,
      image: monicaImg,
    },
  ];

  return (
    <TestimonialsSection
      showFirstButton={false}
      showSecondButton={false}
      firstButtonText="Find out what you should earn"
      secondButtonText={`Get started with ${brandName}`}
      onFirstButtonClick={() => navigateToQuiz(1)}
      onSecondButtonClick={() => navigateToCheckout()}
      testimonials={testimonials}
      modifiers={{
        sectionBg: 'bg-gradient-to-b from-[#FFF8F5] via-[#FFEFEE] to-[#FFE7EB]',
        showImageBg: false,
        shadowLeft: 'linear-gradient(to right, rgba(255, 239, 238, 0.9), transparent)',
        shadowRight: 'linear-gradient(to left, rgba(255, 239, 238, 0.9), transparent)',
        buttonBgColor: '!bg-[#333]',
        buttonRadius: 'rounded-2xl',
      }}
    />
  );
};
